import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import Input from "../../Components/Input";
import useFetch from "../../Hooks/useFetch";
import { apiBaseURL } from "../../Utils/ProjectConstants";
import ActionNotifications from "../../Components/ActionNotifications";
import atlasLogo from "../../Assets/images/AtlasLogo-white.png";
import "./styles.css";
import VerificationCodeInput from "../../Components/VerificationCodeInput";
export default function VerifySecurityCode() {
  const navigate = useNavigate();
  const location = useLocation();
  const fetch = useFetch(navigate);
  const [timer, setTimer] = useState(0);
  const [state, setState] = useState({
    securityCode: "",
    securityCodeError: false,
    notifications: [],
    showSpinner: false,
    maxTimer: 120,
  });
  useEffect(() => {
    if (timer >= state.maxTimer) return;

    const interval = setInterval(() => {
      setTimer((t) => t + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const email = location.state?.email;
  useEffect(() => {
    if (!email) {
      navigate("/login/reset");
    }
  }, [email, navigate]);

  const getCode = async (email) => {
    if (!email) return;

    setTimer(0);

    try {
      const res = await window.fetch(
        `${apiBaseURL}/api/Account/SendSecurityCode?userEmail=${email}`
      );

      const data = await res.json();

      if (!res.ok) {
        setState((prev) => ({
          ...prev,
          notifications: [
            ...prev.notifications,
            {
              isMessageInGDStanding: false,
              message:
                data?.messeges || "Unable to resend code. Please try again.",
            },
          ],
        }));
        return;
      }

      setState((prev) => ({
        ...prev,
        notifications: [
          ...prev.notifications,
          {
            isMessageInGDStanding: true,
            message: "A new security code has been sent.",
          },
        ],
      }));
    } catch {
      setState((prev) => ({
        ...prev,
        notifications: [
          ...prev.notifications,
          {
            isMessageInGDStanding: false,
            message:
              "An error occurred while resending the code. Please try again.",
          },
        ],
      }));
    }
  };

  const formatTime = (t) =>
    `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(
      2,
      "0"
    )}`;

  const onVerify = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let stateValues = { ...state, notifications: [] };

    if (stateValues.securityCode === "") {
      stateValues.securityCodeError = true;
      stateValues.notifications.push({
        message: "Security code is required.",
        isMessageInGDStanding: false,
      });
      return setState(stateValues);
    }

    if (stateValues.securityCodeError) {
      stateValues.notifications.push({
        isMessageInGDStanding: false,
        message: "Please fix all error(s) before submitting.",
      });
    }

    setState({ ...stateValues, showSpinner: true });

    const body = {
      email: email,
      securityCode: parseInt(stateValues.securityCode),
    };

    const res = await window.fetch(
      `${apiBaseURL}/api/Account/ValidateSecurityCode`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );

    const data = await res.json();

    if (res.ok && data.statusCode) {
      navigate("/login/resetPassword", {
        state: { email, securityCode: stateValues.securityCode },
      });
    } else {
      setState((prev) => ({
        ...prev,
        securityCode: "",
        showSpinner: false,
        notifications: [
          ...prev.notifications,
          {
            isMessageInGDStanding: false,
            message: data.messeges || "Invalid security code.",
          },
        ],
      }));
    }

    // if (response.success && response.data.statusCode) {
    //   navigate("/login/resetPassword", {
    //     state: { email, securityCode: stateValues.securityCode },
    //   });
    // } else {
    //   console.log("xxxxxxx", response.errors);

    //   setState({
    //     ...state,
    //     showSpinner: false,
    //     notifications: [].concat(state.notifications, response.data.messeges),
    //   });
    // }
  };

  const renderGrid = () => {
    return (
      <div className="renderFadeIn row g-0">
        <div className="mb-4">
          <h4 className="message">
            If this account exists, we emailed you a security code.
          </h4>

          <h1 className="mb-4">{formatTime(state.maxTimer - timer)}</h1>
        </div>
        <form onSubmit={onVerify}>
          <div className="mb-3">
            <label className="form-label">Security Code</label>
            <VerificationCodeInput
              length={5}
              value={state.securityCode}
              isError={state.securityCodeError}
              onChange={(code) =>
                setState({
                  ...state,
                  securityCode: code,
                  securityCodeError: false,
                })
              }
            />
          </div>
          {timer < state.maxTimer ? (
            <>
              <button className="button yellowBG col-12 mt-3" type="submit">
                {state.showSpinner ? (
                  <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                ) : (
                  "Verify Security Code"
                )}
              </button>
              {/* <button
              className="col-12 button yellowBG mb-3"
              onClick={() => navigate("/request-security-code")}
            >
              Resend Security Code
            </button> */}
            </>
          ) : (
            <button
              className="button yellowBG col-12 mt-3"
              type="submit"
              onClick={() => getCode(email)}
            >
              Resend Security Code
            </button>
          )}
        </form>
        <h5 className="noBold darkGray mt-3 return">
          Return to{" "}
          <Link className="yellow" to="/login">
            Login
          </Link>
        </h5>
      </div>
    );
  };
  return (
    <div id="LoginPage" className="inner ">
      <div id="ResetPassword" className="mt-5 resetpage p-md-5 p-lg-3 col-12">
        <ActionNotifications arrayOfToasts={state.notifications} />
        <div className="reset-container text-center mt-5 col-lg-4 col-12 me-5 p-4">
          <div className="row mb-3">
            <div className="col-12">
              <img alt="Atlas Logo" src={atlasLogo} width="125" />
            </div>
          </div>
          <div className="row g-0">{renderGrid()}</div>
        </div>
      </div>
    </div>
  );
}
